import { ReactComponent as TableAlignBottomIcon } from 'assets/icons/table_align_bottom.svg';
import { ReactComponent as TableAlignMiddleIcon } from 'assets/icons/table_align_middle.svg';
import { ReactComponent as TableAlignTopIcon } from 'assets/icons/table_align_top.svg';
import { VERTICAL_ALIGNMENT } from 'constants/fonts';
import { DropdownPopover } from 'modules/common/components/ToolbarPopover';
import { generateTranslatedOptions } from 'modules/common/components/ToolbarPopover/DropdownPopover';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { MenuProps } from '../../common/toolbar/TextToolbar.types';

const ALIGN_OPTIONS = [
  {
    value: VERTICAL_ALIGNMENT.top,
    label: 'top',
    icon: <TableAlignTopIcon />,
  },
  {
    value: VERTICAL_ALIGNMENT.middle,
    label: 'middle',
    icon: <TableAlignMiddleIcon />,
  },
  {
    value: VERTICAL_ALIGNMENT.bottom,
    label: 'bottom',
    icon: <TableAlignBottomIcon />,
  },
];

export const VerticalAlignment = memo(({ onChange, value, customOptions }: MenuProps) => {
  const { t } = useTranslation('editor_widget_toolbar', {
    useSuspense: false,
    keyPrefix: 'tableToolbar.verticalAlignment',
  });
  const label = t('label');

  const handleUpdate = (verticalAlignment: string) => onChange(verticalAlignment || VERTICAL_ALIGNMENT.top);
  const options = customOptions ?? ALIGN_OPTIONS;
  const selectedIndex = options.findIndex((option) => option.value === (value ?? VERTICAL_ALIGNMENT.top));

  return (
    <DropdownPopover
      selectedIndex={selectedIndex}
      options={generateTranslatedOptions(t, options)}
      toolbarIcon={options[selectedIndex]?.icon}
      toolbarIconVariant={'icon-btn-toolbar'}
      label={label}
      onSelect={handleUpdate}
      w={'6.5rem'}
      justifyContent={'flex-start'}
      closeOnSelect
      returnFocusOnClose={false}
    />
  );
});
VerticalAlignment.displayName = 'VerticalAlignment';
